import isNil from 'lodash/isNil';
import { localContentPrefix } from '../../../../config';
import { http } from '../../../axios';
import { PerformerIn } from '../../../../store/apiLibx';

const url = `${localContentPrefix}/v1/localcontent/performers/:performerId?`;
export interface PerformerParamTypes {
    performer: PerformerIn & { photoDeletion?: boolean; photoUrlObject?: object; id?: string };
    photo: any;
}
export const uploadLocalContentPerformer = ({ performer, photo }: PerformerParamTypes) => {
    const endpointParams = { pathParams: {}, params: {} };

    const data = new FormData();
    data.append('performer', new Blob([JSON.stringify(performer)], { type: 'application/json' }));

    if (!isNil(photo)) {
        data.append('photo', photo);
    }

    if (performer.photoDeletion === true) {
        endpointParams.params['removePhoto'] = JSON.stringify(performer.photoDeletion);
    }

    if (!isNil(performer.id)) {
        endpointParams.pathParams['performerId'] = performer.id;
    }

    return http.post(url, data, endpointParams).then(res => res.data);
};
